
<template>
  <a-card
    :bordered="false"
    :bodyStyle="{ padding: '16px 0', height: '100%' }"
    :style="{ height: '100%' }"
  >
    <div class="account-settings-info-view">
      <a-row :gutter="16" type="flex" justify="center">
        <a-col :md="24" :lg="16">
          <a-form :form="form">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="远传表个数">
              <a-input
                placeholder="远传表个数"
                v-decorator="['waterNum',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="远传水表昨天供水和">
              <a-input
                placeholder="远传水表昨天供水和"
                v-decorator="['waterSupplySum',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本月新增水表数">
              <a-input
                placeholder="本月新增水表数"
                v-decorator="['newThisMonth',{rules: [{ pattern: '^([0-9][0-9]*)?$', message: '请输入数字' }]}]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="居民用水">
              <a-input
                placeholder="居民用水"
                v-decorator="['residentWater',{rules: [{ pattern: '^([0-9][0-9]*)?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="特种行业用水">
              <a-input
                placeholder="特种行业用水"
                v-decorator="['specialWater',{rules: [{ pattern: '^([0-9][0-9]*)?$', message: '请输入数字' }]}]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在线数">
              <a-input
                placeholder="在线数"
                v-decorator="['waterOnLine',{rules: [{ pattern: '^([0-9][0-9]*)?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="库存数">
              <a-input
                placeholder="库存数"
                v-decorator="['waterStock',{rules: [{ pattern: '^([0-9][0-9]*)?$', message: '请输入数字' }]}]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分区水表">
              <a-input
                placeholder="分区水表"
                v-decorator="['zoneWater',{rules: [{ pattern: '^([0-9][0-9]*)?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计费水表">
              <a-input
                placeholder="计费水表"
                v-decorator="['chargingWater',{rules: [{ pattern: '^([0-9][0-9]*)?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否启用">
              <a-radio-group v-decorator="['status']">
                <a-radio :value="0">启用</a-radio>
                <a-radio :value="1">不启用</a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item>
              <a-button
                style="margin-left:200px"
                type="primary"
                :loading="confirmLoading"
                @click="updateData"
              >更新指标设置</a-button>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { baseMixin } from '@/store/app-mixin'

export default {
  name: 'tagerSetting',
  components: {},
  data() {
    return {
      record: {},
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      form: this.$form.createForm(this),
      validatorRules: {},
      url: '/pipe-network/remote_transmission_workbenchs/page',
      addUrl: '/pipe-network/remote_transmission_workbenchs'
    }
  },
  methods: {
    getDataList() {
      this.$http.get(this.url).then(res => {
        let obj = res.data.list[0]
        console.log(typeof obj.status)
        for (let k in obj) {
        if (obj[k]&&k!='status') {
            obj[k] = obj[k].toString()
          }
        }
        this.record = obj
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.record,
              'waterNum',
              'waterSupplySum',
              'newThisMonth',
              'residentWater',
              'specialWater',
              'waterOnLine',
              'waterStock',
              'zoneWater',
              'chargingWater',
              'status'
            )
          )
        })
      })
    },
    //更新数据
    updateData() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          let params = Object.assign(this.record, values)
          this.$http
            .post(this.addUrl, params)
            .then(res => {
              
              if (res.code == 0) {
                this.$message.success(res.message)
                this.getDataList()
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
